import React, {PureComponent, ReactNode} from 'react';
import {Field} from 'redux-form';

import {withGenericFormFieldElements} from 'forms/components/Field/withGenericFormFieldElements';
import Radio, {RadioInnerProps, RadioOuterProps} from 'forms/components/Radio';

class RadioField extends PureComponent<RadioInnerProps> {
    render(): ReactNode {
        return withGenericFormFieldElements(Radio, this.props, false);
    }
}

class RadioFieldOuter extends PureComponent<RadioOuterProps> {
    render(): ReactNode {
        const {
            name,
            label,
            className,
            disabled,
            helpText,
            onAction,
            tooltip,
            wrapperClassName,
            radioValue,
            onFieldBlur,
            onFieldChange,
            fieldIsLoading,
        } = this.props;

        return <Field
            component={RadioField}
            name={name}
            label={label}
            className={className}
            disabled={disabled}
            helpText={helpText}
            onAction={onAction}
            tooltip={tooltip}
            wrapperClassName={wrapperClassName}
            radioValue={radioValue}
            onFieldChange={onFieldChange}
            onFieldBlur={onFieldBlur}
            fieldIsLoading={fieldIsLoading}
        />;
    }
}

export default RadioFieldOuter;
